import React, { useRef, lazy } from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const previews = [{
  image: 'https://cdn.magicpatterns.com/uploads/xgpUAuB3Ny8df6uhfFDD76/pagina_1.webp',
  book: 'TOM 6',
  title: 'Sześć Artykułów Kodeksu Etyki'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/3TUiZFkN7CY1JhvBneUfQz/pagina_2.webp',
  book: 'TOM 5',
  title: 'Szablon Planu Sesji Treningowej'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/m35Pj9mBdWbcjjEdQ43T9b/pagina_3.webp',
  book: 'TOM 4',
  title: 'Sesja 15A: Ruchy w Polu Karnym'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/ryuUg4EP7VEnTAbrFzvQU8/pagina_4.webp',
  book: 'TOM 3',
  title: 'Sesja 21A: Rzut Wolny — Atak'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/qd4Y7kTcTvDxmi9c7nowWP/pagina_5.webp',
  book: 'TOM 2',
  title: 'Sesja 23A: Gra 3v3 — System'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/hX5QHa2kWPNoFHE7aeNwee/pagina_6.webp',
  book: 'TOM 1',
  title: 'Sesja 1B: Moja Piłka, Moja Planeta'
}];
export function ContentPreview() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const scroll = (dir: 'left' | 'right') => {
    if (!scrollRef.current) return;
    const cardWidth = scrollRef.current.querySelector('div[data-card]')?.clientWidth || 320;
    scrollRef.current.scrollBy({
      left: dir === 'left' ? -(cardWidth + 24) : cardWidth + 24,
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-cream-bg py-12 md:py-20 px-4 md:px-6 overflow-hidden" data-id="element-73">
      <div className="max-w-7xl mx-auto" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-12" data-id="element-75">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-navy-primary mb-3 md:mb-4" data-id="element-76">
            Zobacz przykładowe strony wewnątrz
          </h2>
          <p className="text-base md:text-lg text-gray-700 max-w-3xl mx-auto" data-id="element-77">
            Prawdziwe przykłady stron które znajdziesz w każdym tomie:
            formularze, diagramy, checklisty i gotowe tabele.
          </p>
        </motion.div>

        <div className="relative" data-id="element-78">
          {/* Nav buttons (desktop) */}
          <button onClick={() => scroll('left')} className="hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 z-10 w-12 h-12 rounded-full bg-white shadow-lg items-center justify-center hover:bg-gold-accent hover:text-white text-navy-primary transition-colors" aria-label="Przewiń w lewo" data-id="element-79">
            <ChevronLeft className="w-6 h-6" data-id="element-80" />
          </button>
          <button onClick={() => scroll('right')} className="hidden md:flex absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 z-10 w-12 h-12 rounded-full bg-white shadow-lg items-center justify-center hover:bg-gold-accent hover:text-white text-navy-primary transition-colors" aria-label="Przewiń w prawo" data-id="element-81">
            <ChevronRight className="w-6 h-6" data-id="element-82" />
          </button>

          <div ref={scrollRef} className="flex gap-4 md:gap-6 overflow-x-auto snap-x snap-mandatory pb-6 px-4 -mx-4 scroll-smooth" style={{
          scrollbarWidth: 'thin'
        }} data-id="element-83">
            {previews.map((preview, index) => <motion.div key={index} data-card initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.4,
            delay: Math.min(index * 0.08, 0.4)
          }} whileHover={{
            y: -6
          }} className="snap-center flex-shrink-0 w-[260px] sm:w-[280px] md:w-[340px] bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100" data-id="element-84">
                <div className="relative bg-gray-50 aspect-[3/4] overflow-hidden" data-id="element-85">
                  <img src={preview.image} alt={`Przykładowa strona z ${preview.book} — ${preview.title}`} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-86" />
                  <div className="absolute top-3 left-3 bg-gold-accent text-navy-primary text-xs md:text-sm font-bold px-3 py-1.5 rounded-full shadow-md" data-id="element-87">
                    {preview.book}
                  </div>
                </div>
                <div className="p-4 md:p-5" data-id="element-88">
                  <h3 className="font-display font-bold text-navy-primary text-base md:text-lg leading-snug" data-id="element-89">
                    {preview.title}
                  </h3>
                </div>
              </motion.div>)}
            {/* Spacer to allow last card to center on snap */}
            <div className="flex-shrink-0 w-1" aria-hidden="true" data-id="element-90" />
          </div>
        </div>

        <p className="text-center text-gray-500 text-xs sm:text-sm mt-2 md:hidden" data-id="element-91">
          ← Przewiń aby zobaczyć więcej →
        </p>
      </div>
    </section>;
}